/**
 * Frontend mirror of the incident-service status FSM
 * (apps/incident-service/src/services/incident-status.service.ts).
 *
 * Kept deliberately small and well-tested so the UI never offers a status
 * transition the backend will reject with a 400 INVALID_STATE_TRANSITION.
 */

export type IncidentStatusValue =
  | 'OPEN'
  | 'IN_PROGRESS'
  | 'RESOLVED'
  | 'PENDING_CLOSURE_APPROVAL'
  | 'CLOSED'
  | 'CANCELLED';

/**
 * Statuses from which "Mark as Resolved" is a legal transition. Mirrors the
 * backend FSM, where RESOLVED is reachable only from OPEN and IN_PROGRESS
 * (CANCELLED is terminal; CLOSED and PENDING_CLOSURE_APPROVAL have no direct
 * edge to RESOLVED).
 */
export const RESOLVABLE_FROM_STATUSES: readonly IncidentStatusValue[] = ['OPEN', 'IN_PROGRESS'];

/** Whether an incident in `status` can be marked resolved without a 400. */
export function canMarkIncidentResolved(status: string | null | undefined): boolean {
  const normalized = (status ?? '').toUpperCase() as IncidentStatusValue;
  return RESOLVABLE_FROM_STATUSES.includes(normalized);
}
